import {
  FAILURE_GET_JACKTOP_TOKEN,
  GET_JACKTOP_TOKEN,
  SUCCESS_GET_JACKTOP_TOKEN,
} from '../../actions/jacktopGames/jacktopGames'
import { getLanguageType } from '../../constants/Language'
import { jacktopConstants } from '../components/games/jacktop/jacktop_constants'

const initialState = {
  fetching: false,
  token: null,
  error: null,
}

export default function jacktopGamesReducer(state, action) {
  if (state === undefined) {
    return initialState
  }

  switch (action.type) {
    case GET_JACKTOP_TOKEN:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case SUCCESS_GET_JACKTOP_TOKEN: {
      state.token = action.data.token

      const langCode = getLanguageType(action.languageId).name

      const params = {
        lng: langCode,
        clientId: jacktopConstants.client_id,
        tokenAuth: action.data.token,
        game_id: action.gameId,
      }
      const url = jacktopConstants.server + new URLSearchParams(params)
      window.location.assign(url)
      return {
        ...state,
        error: null
      }
    }
    case FAILURE_GET_JACKTOP_TOKEN:
      return {
        ...state,
        token: null,
        fetching: false,
        error: action.data
      }
  }

  return state
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/jacktopGamesReducer.js